import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success("Welcome back");
      navigate(u.role === "admin" ? "/admin" : (location.state?.from || "/account"));
    } catch (e2) {
      setErr(formatApiError(e2.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="login-page" className="min-h-[80vh] grid place-items-center px-5 py-16">
      <div className="w-full max-w-md">
        <div className="text-center mb-10"><Logo className="h-16 mx-auto" /></div>
        <h1 className="font-serif text-4xl text-[var(--bronze)] text-center">Welcome Back</h1>
        <p className="text-center text-[var(--olive)] mt-2">Sign in to your KKashigari account</p>
        <form onSubmit={submit} className="mt-10 space-y-5">
          <div>
            <label className="uplabel text-[0.62rem] block mb-1.5">Email</label>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email"
              className="w-full bg-transparent border border-[var(--line)] px-4 py-3 outline-none text-[var(--bronze)] focus:border-[var(--olive)] transition-colors" />
          </div>
          <div>
            <label className="uplabel text-[0.62rem] block mb-1.5">Password</label>
            <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password"
              className="w-full bg-transparent border border-[var(--line)] px-4 py-3 outline-none text-[var(--bronze)] focus:border-[var(--olive)] transition-colors" />
          </div>
          {err && <p data-testid="login-error" className="text-sm text-[var(--maroon)]">{err}</p>}
          <button type="submit" disabled={loading} data-testid="login-submit" className="btn-primary w-full uplabel py-4 disabled:opacity-60">{loading ? "Signing in…" : "Sign In"}</button>
        </form>
        <p className="text-center text-sm text-[var(--olive)] mt-6">
          New to KKashigari? <Link to="/register" className="text-[var(--bronze)] link-underline">Create an account</Link>
        </p>
      </div>
    </div>
  );
}
